module.exports = __webpack_public_path__ + "order/img/MC.6b7ca076.svg";